var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXAlt = function SvgXAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.946 23-5.55-7.91L3.45 23H.51l8.582-9.769L.51 1h7.546l5.23 7.455L19.84 1h2.939l-8.184 9.316L23.492 23h-7.546Zm3.273-2.23H17.24L4.718 3.23h1.98l5.014 7.023.868 1.219 6.639 9.298Z",
    fill: "currentColor"
  })));
};
export default SvgXAlt;